import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Segmented, Tooltip } from "antd";
import { AppstoreOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { actions as commonActions } from "../../store/commonRedux/actions";

export const VIEW_CARDS = "cards";
export const VIEW_TABLE = "table";

/* Cards or table for a list screen, remembered per module.
 *
 * The choice is a preference, not navigation, so it stays out of the URL and
 * lives in the common slice — a link someone shares should open the list, not
 * impose how they read it. It is per module because the right default differs:
 * a roster of people reads as cards, a ledger of time entries reads as rows. */
export const useListView = (module, fallback = VIEW_CARDS) => {
  const dispatch = useDispatch();
  const view = useSelector(({ common }) => common.listView?.[module]);

  return [
    view || fallback,
    (next) => dispatch(commonActions.setListView(module, next)),
  ];
};

const ViewToggle = ({ value, onChange, className = "" }) => (
  <Segmented
    className={className}
    value={value}
    onChange={onChange}
    options={[
      {
        value: VIEW_CARDS,
        icon: (
          <Tooltip title="نمای کارتی">
            <AppstoreOutlined />
          </Tooltip>
        ),
      },
      {
        value: VIEW_TABLE,
        icon: (
          <Tooltip title="نمای جدولی">
            <UnorderedListOutlined />
          </Tooltip>
        ),
      },
    ]}
  />
);

export default ViewToggle;
